import { useQuery } from '@tanstack/react-query';

import { fetchAllSaversCarriers } from '../data-provider/get-all-savers-carriers';

export type SaversCarrierParams = {
  customerKey: number;
};

export const useGetSaversCarriers = (params: SaversCarrierParams) => {
  return useQuery({
    enabled: Boolean(params.customerKey),
    queryFn: () => fetchAllSaversCarriers(),
    queryKey: ['savers-carriers-list', params.customerKey],
    staleTime: Number.POSITIVE_INFINITY,
  });
};
